import { IconName } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CoursesRecieved } from "@mikros/library";
import { ComponentDialog, Confirm, MenuOptions } from "@mikros/shared-ui";
import { Dialog } from "@progress/kendo-react-dialogs";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import ApiServices from "../../service/apiService";
import { Popover, Whisper } from "rsuite";
import Account from "../../utils/apiConfig";
import { ShareCourseCustomerSearch } from "./shareCourseCustomerSearch";
import { Loading } from "../common/loading";
import { Alert } from "@mikros/shared-ui";
import ErrorHandler from "../../utils/errorConfig";
import { useNavigate } from "react-router-dom";

export interface CourseCardProps {
  courseDetail: CoursesRecieved;
  onReload?: () => void;
  handleGoToCourse: (e: string) => void;
  backGroundImage: string;
}

export function CourseCard(props: CourseCardProps) {
  const intl = useIntl();
  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();
  const navigate = useNavigate();
  const options = [
    {
      icon: (
        <FontAwesomeIcon
          icon={["far", "pencil" as IconName]}
          className="fa-fa w-4 h-4 text-mk-primary-bright"
          color="mk-primary-bright"
        />
      ),
      label: intl.formatMessage({ id: "courses.courseCard.renameLabel" }),
      value: "rename",
      labelWidth: 15,
    },
    {
      icon: (
        <FontAwesomeIcon
          icon={["far", "copy" as IconName]}
          className="fa-fw w-4 h-4 text-mk-primary-bright"
          color="mk-primary-bright"
        />
      ),
      label: intl.formatMessage({ id: "courses.courseCard.duplicateLabel" }),
      value: "duplicate",
      labelWidth: 15,
    },
    {
      icon: (
        <FontAwesomeIcon
          icon={["far", "share" as IconName]}
          className="fa-fa w-4 h-4 text-mk-primary-bright"
          color="mk-primary-bright"
        />
      ),
      label: intl.formatMessage({ id: "courses.courseCard.shareLabel" }),
      value: "share",
      labelWidth: 15,
    },
    {
      icon: (
        <FontAwesomeIcon
          icon={["far", "box-archive" as IconName]}
          className="fa-fw w-4 h-4 text-mk-primary-bright"
          color="mk-primary-bright"
        />
      ),
      label:
        props.courseDetail.status !== "ARCHIVED"
          ? intl.formatMessage({ id: "courses.courseCard.archiveLabel" })
          : intl.formatMessage({ id: "courses.courseCard.unarchiveLabel" }),
      value: "archive",
      labelWidth: 15,
    },
  ];
  const maxLength = 50;
  const [visible, setVisible] = React.useState<boolean>(false);
  const [courseRename, setCourseRename] = useState(
    props.courseDetail.courseName
  );
  const [duplicateData, setDuplicateData] = useState(true);
  const [shareData, setShareData] = useState(true);

  const [isCourseHovered, setIsCourseHovered] = useState<boolean>(false);
  const [shareDialog, setShareDialog] = useState<boolean>(false);
  const [successShareDialog, setSuccessShareDialog] = useState<boolean>(false);
  const [targetAccountId, setTargetAccountId] = useState<string>("");
  const [selectCustomerDialog, setSelectCustomerDialog] =
    useState<boolean>(false);
  const [publishCourseDialog, setPublishCourseDialog] =
    useState<boolean>(false);

  const [loader, setLoader] = React.useState<boolean>(false);
  console.log("loader bool value", loader);
  console.log("print the target account id in course card", targetAccountId);
  console.log("course detail status", props.courseDetail.status);

  //error
  const [errorFlag, setErrorFlag] = useState<boolean>(false);

  const courseSpeaker = (
    <Popover
      title={`${intl.formatMessage({
        id: "course.courseCard.fullCourseNamePopover",
      })}`}
    >
      <p>{props.courseDetail.courseName}</p>
    </Popover>
  );
  const toggleShareDialog = () => {
    setShareDialog(!shareDialog);
  };
  const toggleSuccessShareDialog = () => {
    setSuccessShareDialog(!successShareDialog);
  };

  const toggleDialog = () => {
    setVisible(!visible);
  };
  const togglePublishCourseDialog = () => {
    setPublishCourseDialog(!publishCourseDialog);
  };
  const toggleSelectCustomerDialog = () => {
    setSelectCustomerDialog(!selectCustomerDialog);
  };


  const handleTextBoxChange = (text: string) => {
    setCourseRename(text);
  };

  async function menuSelected(data: any) {
    if (data === "rename" && props.courseDetail.status !== "PUBLISHED") {
      toggleDialog();
    }
    if (data === "rename" && props.courseDetail.status === "PUBLISHED") {
      togglePublishCourseDialog();
    }
    if (data === "duplicate") {
      setDuplicateData(true);
      let dupBody = {
        option: "duplicate",
        courseId: props.courseDetail.courseId,
        fromAccntId: accountInstance.accntId,
        toAccntId: "",
      };
      let api = ApiServices.getInstance();
      if (accountInstance.accntId) {
        api
          .makeRequest(
            `${accountInstance.accntId}/course/${props.courseDetail.courseId}/renameDupCourse`,
            "POST",
            dupBody
          )
          .then(async (res) => {
            if (res && res.errorMessage) {
              setErrorFlag(true);
              await errorInstance.updateErrorCode(res.errorMessage);
              return;
            }
            if (props.onReload) {
              props.onReload();
            }
            console.log("dup response", res);
          });
      }
    }
    if (data === "share") {
      setShareDialog(true);
    }
    if (data === "archive") {
      console.log("Enter when it is archive");
      let archBody = {
        courseId: props.courseDetail.courseId,
        status: props.courseDetail.status === "ARCHIVED" ? false : true,
      };
      console.log("arch body", archBody);
      let api = ApiServices.getInstance();
      if (accountInstance.accntId) {
        api
          .makeRequest(
            `${accountInstance.accntId}/course/${props.courseDetail.courseId}/courseUpdStsArch`,
            "POST",
            archBody
          )
          .then(async (res) => {
            if (res && res.errorMessage) {
              setErrorFlag(true);
              await errorInstance.updateErrorCode(res.errorMessage);
              return;
            }
            if (props.onReload) {
              props.onReload();
            }
          });
      }
    }
  }

  

  return (
    <div>
      {loader && (
        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-50 z-20">
          <Loading></Loading>
        </div>
      )}

      {publishCourseDialog && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: "course.courseCard.publishCourseError",
            })}
            buttonText={`${intl.formatMessage({ id: "users.buttonText.Ok" })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              togglePublishCourseDialog();
            }}
          />
        </Dialog>
      )}
      {errorFlag && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: errorInstance.errorCode,
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              setErrorFlag(false);
              navigate("/courses");
            }}
          />
        </Dialog>
      )}

      {shareDialog && (
        <Dialog className="requireDialogue">
          <ComponentDialog
            component={() => (
              <ShareCourseCustomerSearch
                targetAccountIdFunction={setTargetAccountId}
              ></ShareCourseCustomerSearch>
            )}
            successText={"Share"}
            failureText={"Cancel"}
            onSuccess={() => {
              if (targetAccountId !== "") {
                toggleShareDialog();
                setShareData(true);
                let dupBody = {
                  option: "share",
                  courseId: props.courseDetail.courseId,
                  fromAccntId: accountInstance.accntId,
                  toAccntId: targetAccountId,
                };
                let api = ApiServices.getInstance();
                if (accountInstance.accntId) {
                  api
                    .makeRequest(
                      `${accountInstance.accntId}/course/${props.courseDetail.courseId}/renameDupCourse`,
                      "POST",
                      dupBody
                    )
                    .then(async (res) => {
                      if (res && res.errorMessage) {
                        setErrorFlag(true);
                        await errorInstance.updateErrorCode(res.errorMessage);
                        return;
                      }
                      toggleSuccessShareDialog();
                      console.log("share response", res);
                    });
                }
              } else if (targetAccountId === "") {
                toggleSelectCustomerDialog();
              }
            }}
            onFailure={() => {
              toggleShareDialog();
            }}
          />
        </Dialog>
      )}
      {selectCustomerDialog && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: "course.courseCard.shareCourseError",
            })}
            buttonText={intl.formatMessage({
              id: "users.buttonText.Ok",
            })}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              toggleSelectCustomerDialog();
            }}
          />
        </Dialog>
      )}
      {successShareDialog && (
        <Dialog className="confirmSuccessDialogue">
          <Alert
            description={intl.formatMessage({
              id: "course.courseCard.shareCourseSuccess",
            })}
            buttonText={intl.formatMessage({
              id: "users.buttonText.Ok",
            })}
            icon={"successShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgSuccess",
            })}
            backgroundColor={"mk-bright-green"}
            onClick={() => {
              toggleSuccessShareDialog();
            }}
          />
        </Dialog>
      )}

      {visible && (
        <Dialog className="renameDialog">
          <Confirm
            successText={intl.formatMessage({ id: "user.cohortList.save" })}
            failureText={intl.formatMessage({
              id: "users.cohortDisplay.cancel",
            })}
            textBoxRequired={true}
            intialTextValue={props.courseDetail.courseName}
            onSuccess={() => {
              let body = { ...props.courseDetail };
              let renameBody = {
                option: "rename",
                courseId: props.courseDetail.courseId,
                fromAccntId: accountInstance.accntId,
                toAccntId: "",
                courseName: courseRename,
              };
              body.courseName = courseRename;
              let api = ApiServices.getInstance();
              if (accountInstance.accntId) {
                api
                  .makeRequest(
                    `${accountInstance.accntId}/course/${props.courseDetail.courseId}/renameDupCourse`,
                    "POST",
                    renameBody
                  )
                  .then(async (res) => {
                    if (res && res.errorMessage) {
                      setErrorFlag(true);
                      await errorInstance.updateErrorCode(res.errorMessage);
                      return;
                    }
                    if (props.onReload) {
                      props.onReload();
                    }

                    console.log("form response", res);
                  });
              }
              toggleDialog();
            }}
            onFailure={toggleDialog}
            textBoxValue={handleTextBoxChange}
          />
        </Dialog>
      )}

      {duplicateData && (
        <div
          className="flex flex-col relative"
          onClick={
            !visible
              ? () => props.handleGoToCourse(props.courseDetail.courseId)
              : () => {}
          }
        >
          <div className="w-full flex justify-end items-center text-white">
            <div
              className="absolute hover:cursor-pointer mt-8 w-4 h-4 flex justify-center items-center z-40 pr-2"
              onClick={(event) => {
                event.stopPropagation();
              }}
            >
              <MenuOptions
                options={options}
                onSelect={(data: any) => {
                  menuSelected(data);
                }}
              >
                {/* <FontAwesomeIcon
                  onClick={(event) => {
                    event.stopPropagation();
                  }}
                  icon={["far", "fa-ellipsis" as IconName]}
                  className="fa-fw rotate-90"
                  color="white"
                /> */}

                <div
                  onClick={(event) => event.stopPropagation()}
                  className="flex items-center justify-center rounded-full p-1 hover:bg-mk-grey transition"
                >
                  <FontAwesomeIcon
                    icon={["far", "fa-ellipsis" as IconName]}
                    className="fa-fw rotate-90"
                    color="white"
                  />
                </div>
              </MenuOptions>
            </div>
          </div>

          <div
            className={`relative overflow-hidden  hover:cursor-pointer h-[60%] w-[100%] bg-opacity-40 shadow-xl flex flex-col rounded-xl justify-center items-center`}
          >
            <img
              className="relative w-full h-full"
              src={props.backGroundImage}
            />
            <div className="absolute z-10 right-0 bottom-0 h-16 w-16">
              <div
                className={`absolute  transform rotate-[-45deg] 
                       ${
                         props.courseDetail.status === "DRAFT"
                           ? "bg-mk-orange"
                           : props.courseDetail.status === "ARCHIVED"
                           ? "bg-black"
                           : props.courseDetail.status === "INREVIEW"
                           ? "bg-green-600"
                           : props.courseDetail.status === "PUBLISHED"
                           ? "bg-blue-500"
                           : props.courseDetail.status === "INPROGRESS"
                           ? "bg-mk-red"
                           : "bg-mk-red"
                       }  text-[10px] text-center flex justify-center items-center text-white font-semibold py-1 right-[-50px] top-[25px] w-40 h-4`}
              >
                {props.courseDetail.status === "DRAFT"
                  ? intl.formatMessage({
                      id: "courses.courseCard.status.Draft",
                    })
                  : props.courseDetail.status === "ARCHIVED"
                  ? intl.formatMessage({
                      id: "courses.courseCard.status.Archived",
                    })
                  : props.courseDetail.status === "INREVIEW"
                  ? intl.formatMessage({
                      id: "courses.courseCard.status.InReview",
                    })
                  : props.courseDetail.status === "PUBLISHED"
                  ? intl.formatMessage({
                      id: "courses.courseCard.status.Published",
                    })
                  : intl.formatMessage({
                      id: "courses.courseCard.status.InProgress",
                    })}
              </div>
            </div>

            <div
              style={{ background: "rgba(0,0,0,0.2)" }}
              className={`absolute w-full h-full z-10 flex flex-col justify-between items-center xl:text-base font-bold xl:w-32 sm:w-20  text-center text-white`}
            >
              <div className="w-full pt-4">
                <div
                  className="w-full flex justify-center items-center p-2"
                  onMouseEnter={() =>
                    props.courseDetail.courseName.length > maxLength &&
                    setIsCourseHovered(true)
                  }
                  onMouseLeave={() => setIsCourseHovered(false)}
                >
                  {isCourseHovered &&
                  props.courseDetail.courseName?.length > maxLength ? (
                    <Whisper
                      placement="top"
                      controlId="control-id-hover"
                      speaker={courseSpeaker}
                      trigger="hover"
                    >
                      <div>
                        {props.courseDetail.courseName.slice(0, maxLength) +
                          "..."}
                      </div>
                    </Whisper>
                  ) : props.courseDetail.courseName?.length > maxLength ? (
                    props.courseDetail.courseName.slice(0, maxLength) + "..."
                  ) : (
                    props.courseDetail.courseName
                  )}
                </div>
              </div>
              <div className="w-full flex items-center pl-3 pb-3 justify-start">
                <div className="text-shadow w-18 text-xs text-start text-white">
                  {props.courseDetail.chapterCount !== undefined && (
                    <div>
                      {props.courseDetail.chapterCount === 1
                        ? intl.formatMessage({
                            id: "courses.courseCard.oneChapter",
                          })
                        : `${
                            props.courseDetail.chapterCount
                          } ${intl.formatMessage({
                            id: "courses.courseCard.chapters",
                          })}
                        `}
                    </div>
                  )}
                  {props.courseDetail.cardCount !== undefined && (
                    <div>
                      {props.courseDetail.cardCount === 1
                        ? intl.formatMessage({
                            id: "courses.courseCard.oneCard",
                          })
                        : `${props.courseDetail.cardCount} ${intl.formatMessage(
                            {
                              id: "courses.courseCard.cards",
                            }
                          )}`}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
